import { GridGap, responsiveness } from "../../assets/styles/parameters";

import styled from "styled-components";

export const Layout = ({ layout, children, ...otherProps }) => {
  switch (layout) {
    case 3:
      return <Layout3 {...otherProps}>{children}</Layout3>;
    case 2:
      return <Layout2 {...otherProps}>{children}</Layout2>;
    default:
      return <Layout1 {...otherProps}>{children}</Layout1>;
  }
};

export default Layout;

const BaseLayout = styled.main`
  grid-area: main;
  padding: 0 1rem 2rem;

  @media screen and (max-width: ${responsiveness.mobile1}) {
    padding: 0 0.5rem;
  }
`;

const Layout1 = styled(BaseLayout)`
  display: grid;
  grid-template-columns: 1fr;
  margin-top: 0.5rem;
  @media screen and (max-width: ${responsiveness.mobile1}) {
    grid-template-columns: 1fr;
  }
`;

const Layout2 = styled(BaseLayout)`
  display: grid;
  grid-template-columns: ${({ reverse }) =>
    reverse ? "1fr 0.4fr" : "0.4fr 1fr"};
  gap: ${GridGap.default};

  @media screen and (min-width: ${responsiveness.maxWidth}) {
    grid-template-columns: 0.3fr 1fr;
  }

  /* Stack to single column on tablet and below */
  @media screen and (max-width: ${responsiveness.ipadMin}) {
    grid-template-columns: 1fr;
  }
`;

const Layout3 = styled(BaseLayout)`
  display: grid;
  grid-template-columns: 0.35fr 1fr 0.35fr;

  /* Two columns on tablet */
  @media screen and (max-width: ${responsiveness.ipadMin}) {
    grid-template-columns: repeat(2, 1fr);
  }

  /* Single column on mobile */
  @media screen and (max-width: ${responsiveness.mobile1}) {
    grid-template-columns: 1fr;
  }
`;
